export default "__VITE_ASSET__1ef3157c__"